import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import {DialogContent, IconButton,} from "@mui/material";
import {Close} from "@mui/icons-material";
import DialogTitle from "@mui/material/DialogTitle";
import {Measurement} from "./Measurement.tsx";
import {IMeasurement} from "../../../types/models/Calibration.ts";

export interface MeasurementDialogProps {
    open: boolean;
    handleClose: () => void;
    measurement: IMeasurement;
}

export function MeasurementDialog(props: Readonly<MeasurementDialogProps>) {
    const {handleClose, open, measurement} = props;

    if (!measurement){
        return <></>;
    }

    return (<Dialog
            onClose={handleClose}
            open={open}
            fullWidth={false}
            maxWidth={"sm"}
            scroll={"paper"}
            sx={{my: 2}}
        >
            <DialogTitle sx={{m: 0, p: 2}} id={measurement._id}>
                {measurement.type}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    color: theme.palette.grey[500],
                })}>
                <Close/>
            </IconButton>
            <DialogContent dividers>
                <Measurement measurement={measurement}/>
            </DialogContent>
        </Dialog>
    );
}
